import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryInvalidNumberOfBricks extends AnnualSummaryError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks is not a number', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default AnnualSummaryInvalidNumberOfBricks;
